import classNames from "classnames";
import React, { useMemo } from "react";

type MarqueeCarouselPropsType = {
  direction?: "left" | "right";
  paused?: boolean;
  pauseOnHover?: boolean;
  speedMultipler?: number;
  pointer?: boolean;
  children: React.ReactNode;
};

const MarqueeCarousel = (props: MarqueeCarouselPropsType) => {
  const {
    direction = "left",
    children,
    paused = false,
    pauseOnHover = false,
    pointer = false,
    speedMultipler = 5,
  } = props;

  const numberOfChildrens = useMemo(
    () => React.Children.count(children),
    [children]
  );

  const animationSpeed = useMemo(() => {
    return `${numberOfChildrens * speedMultipler}s`;
  }, [numberOfChildrens, speedMultipler]);

  const marqueeSliderClassName = useMemo(
    () =>
      classNames(
        `${!pointer ? "pointer-events-none" : "cursor-pointer"} flex`,
        {
          "group-hover/marquee-container:animate-pause": pauseOnHover,
        },
        {
          "animate-marquee-left": direction === "left" && !paused,
          "animate-marquee-right": direction === "right" && !paused,
        }
      ),
    [direction, pauseOnHover, paused, pointer]
  );

  return (
    <div
      className={classNames(
        // `group flex w-full  overflow-x-hidden ${gap} hover:animate-pause hover:bg-primary`
        `group/marquee-container ${
          !pointer ? "pointer-events-none" : "cursor-pointer"
        } -z-0 flex w-full overflow-y-visible`,
        "z-0 hover:z-[1]"
      )}
    >
      <div
        className={marqueeSliderClassName}
        style={{
          animationDuration: animationSpeed,
        }}
      >
        {children}
      </div>
      <div
        className={marqueeSliderClassName}
        style={{
          animationDuration: animationSpeed,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MarqueeCarousel;
